// Kept Leaflet-free and separate from GeoreferencedMap.tsx: ControlPointPickerMap.tsx
// (a static import from App.tsx, not lazy) only needs these two strings, and
// importing them from GeoreferencedMap.tsx directly pulled the whole
// react-leaflet/leaflet module into the main bundle regardless of
// GeoreferencedMap's own `lazy()` wrapping.

export const OSM_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

// UI redesign phase 6 — a dark basemap was planned via CARTO Dark Matter's
// old free/keyless raster endpoint (basemaps.cartocdn.com), confirmed LIVE
// to now require an API key (CARTO's own "API KEY REQUIRED" watermark tiled
// over the map) — a real-world policy change since that plan was written,
// not a config mistake here. Configuring a key is a separate, bigger
// decision (where it's stored, whether this still-no-backend app should
// depend on one at all) than this pass. See networkMap.css's own
// `.georeferenced-map-container .leaflet-tile-pane` for what shipped
// instead: a CSS filter over the SAME OSM tiles used in light mode, no
// external dependency at all.
